import { Component, OnDestroy, OnInit } from '@angular/core';
import {map, switchMap} from 'rxjs/internal/operators';
import {of, Subscription} from 'rxjs';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {InternalDocument} from '../../shared/model/internal-document';
import {DocumentService} from '../../shared/service/document.service';
import {FinalClientPlaceService} from '../../components/account/services/final-client-place.service';
import {ContractService} from '../../components/account/services/contract.service';

@Component({
  selector: 'app-contract-index',
  templateUrl: './contract-index.component.html',
  styleUrls: ['./contract-index.component.scss']
})
export class ContractIndexComponent implements OnInit, OnDestroy {

  indexForm: FormGroup;
  placeCode: string;
  contractId: number;
  contractNumber: string;
  routeDataSub: Subscription;
  indexPhotos: InternalDocument[] = [];
  currentDay = new Date();

  constructor(
    public documentService: DocumentService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private placeService: FinalClientPlaceService,
    private contractService: ContractService
  ) {
    this.createIndexForm();
  }

  ngOnInit(): void {
    this.routeDataSub = this.route.queryParams.pipe(
      map(params => {
        this.placeCode = params.placeCode;
        this.contractId = +params.contractId;
        this.contractNumber = params.contractNumber;
        return this.placeCode;
      }),
      switchMap(
        placeCode => placeCode ? this.placeService.getFCPlaceIndexDescription(placeCode) : of(null)
      )
    ).subscribe((placeIndexDescription) => {
      if (placeIndexDescription && placeIndexDescription.indexDesc) {
        this.indexForm.patchValue({indexDescription: placeIndexDescription.indexDesc});
      }
    });
  }

  createIndexForm() {
    this.indexForm = this.formBuilder.group({
      indexDate: [''],
      indexDescription: [{value: '', disabled: true}],
      indexValue: ['']
    });
  }

  uploadCounterIndexPhoto(fileList: FileList): void {
    console.log('upload', fileList);
    if (fileList.length > 0) {
      for (let i = 0; i < fileList.length; i++) {
        if (!this.documentNameExists(this.indexPhotos, fileList.item(i).name)) {
          const document: InternalDocument = {
            fileName: fileList.item(i).name,
            fileByteSize: fileList.item(i).size,
            fileType: fileList.item(i).type,
            file: fileList.item(i)
          };
          this.indexPhotos.push(document);
        }
      }
    }
  }

  onCancel() {
    history.back();
  }

  onSubmit() {
    const index = {
      contractId: this.contractId,
      indexDate: this.indexForm.get('indexDate').value,
      indexValue: this.indexForm.get('indexValue').value
    };
    const formData: FormData = new FormData();
    formData.append('index', JSON.stringify(index));
    if (this.indexPhotos) {
      for (const indexPhoto of this.indexPhotos) {
        if (!indexPhoto.file) {
          continue;
        }
        formData.append('indexPhotos', indexPhoto.file, indexPhoto.fileName);
      }
    }

    this.contractService.sendIndexCompletion(formData).subscribe(() => history.back());
  }

  ngOnDestroy(): void {
    if (this.routeDataSub) {
      this.routeDataSub.unsubscribe();
    }
  }

  documentNameExists(documentList: InternalDocument[], fileName: string): boolean {
    return documentList.some(el => el.fileName === fileName);
  }

  deleteDocument(documentList: InternalDocument[], index: number): void {
    if (documentList) {
      documentList.splice(index, 1);
    }
  }

}
